// Runs `task(item)` for each item in turn (the API handles one record per
// request). Failures are collected instead of aborting or being hidden.
//   onProgress(done)  - called after every item
// Resolves to { succeeded: [{ item, result }], failed: [{ item, error }] }.
export async function runBatch(items, task, onProgress) {
  const succeeded = [];
  const failed = [];
  for (const item of items) {
    try {
      succeeded.push({ item, result: await task(item) });
    } catch (error) {
      failed.push({ item, error });
    }
    onProgress?.(succeeded.length + failed.length);
  }
  return { succeeded, failed };
}
